"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaturalPerson = void 0;
class NaturalPerson {
    address;
    occupation;
    incomeRange;
}
exports.NaturalPerson = NaturalPerson;
//# sourceMappingURL=NaturalPerson.js.map